import api from "@/lib/api";

export const AUTOPILOT_MODES = [
  { v: "approval", title: "Tunggu kelulusan saya", desc: "AI sediakan draf setiap hari. Anda semak, edit & luluskan sebelum ia masuk giliran." },
  { v: "auto", title: "Terus jadual & post automatik", desc: "Post AI terus masuk giliran pada masa yang ditetapkan. Helper (Mod Latar) akan post sendiri." },
];

export const TONE_OPTIONS = [
  { v: "santai", l: "Santai" },
  { v: "profesional", l: "Profesional" },
  { v: "jualan", l: "Jualan" },
  { v: "lucu", l: "Lucu" },
];

export const saveAutopilot = (patch) => api.put("/autopilot", { ...patch, tz_offset: new Date().getTimezoneOffset() });
